export default __webpack_public_path__ + "scripts/resource/f383155fa7eb28b4ed8593ef134dfbce.svg";